import React from "react";

function CheckDependencyModal({
  title,
  message,
  onClose,
  okButtonLabel,
  okButtonClick,
}) {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="fs-9">{message}</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={okButtonClick}
              >
                {okButtonLabel || "Okay"}
              </button>
              {/* <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={onClose}
              >
                Close
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default CheckDependencyModal;
